import { Helmet } from 'react-helmet';

export const PageTitleHelmet = ({ children: title }: { children: React.ReactNode}) => {
  const siteName = "Peachjar";
  return (
    <Helmet>
      <title>{`${title} | ${siteName}`}</title>
    </Helmet>
  );
};
